import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { xor } from 'lodash';
import { IMPACT_SCALE } from '../../lib/schema.js';

ScaleFilter.defaultProps = {
  selectedScale: [],
};

function ScaleFilter({ selectedScale, navigateAction }) {
  const selectedCount = selectedScale.length;

  const handleSelect = useCallback(
    (scale) =>
      navigateAction({
        scale: scale ? xor(selectedScale, [scale]) : [],
      }),
    [selectedScale]
  );

  const renderMenuItem = useCallback(
    (scale) => (
      <React.Fragment key={scale}>
        <MenuItem
          active={selectedScale.includes(scale)}
          eventKey={scale}
          onSelect={handleSelect}
        >
          {scale}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedScale]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Scale</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="scale-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>

          <MenuItem divider />
          {IMPACT_SCALE.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default ScaleFilter;
